import type { Breadcrumb, ErrorEvent } from '@sentry/react';

import { normalizePath } from '@luna/router';

function normalizeUrl(url = ''): string {
    if (url.includes('/https:')) {
        return normalizeUrl(removeRproxyUrl(url));
    }

    const parsedUrl = new URL(url);
    parsedUrl.pathname = normalizePath(`#${parsedUrl.pathname}`);
    parsedUrl.search = '';
    parsedUrl.hash = normalizePath(parsedUrl.hash);

    return parsedUrl.toString();
}

function removeRproxyUrl(url: string): string | undefined {
    return url.replace(/.*\/https:/, 'https:');
}

const urlRegex = /https?:\/\/[^\s]+/g;

export function normalizeBreadcrumb(breadcrumb: Breadcrumb): Breadcrumb {
    if (breadcrumb.category === 'fetch' && breadcrumb.data?.url) {
        return {
            ...breadcrumb,
            data: {
                ...breadcrumb.data,
                url: normalizeUrl(breadcrumb.data.url),
            },
        };
    }

    if (breadcrumb.category === 'navigation' && breadcrumb.data) {
        return {
            ...breadcrumb,
            data: {
                ...breadcrumb.data,
                from: normalizeUrl(breadcrumb.data.from),
                to: normalizeUrl(breadcrumb.data.to),
            },
        };
    }

    if (breadcrumb.category === 'console' && breadcrumb.message) {
        const sanitizedMessage = breadcrumb.message.replace(urlRegex, (url) => normalizeUrl(url));
        return {
            ...breadcrumb,
            message: sanitizedMessage,
        };
    }

    return breadcrumb;
}

function keepPathInUrlAndFragment(normalizedUrl: string): string {
    return normalizedUrl.replace(/#(.*)/, '/$1#/$1');
}

export function normalizeEvent(event: ErrorEvent): ErrorEvent {
    if (event.request?.url) {
        return {
            ...event,
            request: {
                ...event.request,
                url: keepPathInUrlAndFragment(normalizeUrl(event.request.url)),
            },
        };
    }
    return event;
}
